import { type FilterLegacy } from '@verantos-dev/types-cohorts';

export const getNextFilterForInputFieldValueUpdate = (
  filters: FilterLegacy[],
  filterId: string,
  inputFieldId: string,
  value: string
) => {
  return filters.map((filter) => {
    if (filter.id === filterId) {
      // Update the specified input field value while preserving all other fields
      const currentInputFieldIndex = filter.inputFields.findIndex(
        (inputField) => inputField.id === inputFieldId
      );

      const inputFields = filter.inputFields.map((inputField, index) => {
        if (index === currentInputFieldIndex) {
          return { ...inputField, value, dirty: true };
        }
        return inputField;
      });

      return {
        ...filter,
        inputFields,
        updated: inputFieldId, // used in addSimpleEvent fn
      };
    }
    return filter;
  });
};
